import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";
import {BankPluginConfig} from "../models/bank-plugin-config";

@Injectable({
  providedIn: 'root'
})
export class BankPluginConfigService {

  constructor(private http: HttpClient) {
  }

  getConfig(tipo: number): Observable<any> {
    return this.http.get(environment.apiHost + `/secure/bank-plugin/config/${tipo}`).pipe(map((response: any) => response.data.integration as BankPluginConfig));
  }

  saveConfig(form, fileCrt, fileKey): Observable<any> {
    const formData: FormData = new FormData();
    if(fileCrt) {
      formData.append('crtFile', fileCrt[0]);
    }
    if(fileKey) {
      formData.append('keyFile', fileKey[0]);
    }
    formData.append('integration', new Blob([JSON.stringify(form)], {type: "application/json"}));
    console.log(formData);
    let hd = new HttpHeaders();
    hd = hd.set('Content-Type', 'multipart/form-data');
    const options = {
      headers: hd
    };
    return this.http.put(
        environment.apiHost + '/secure/bank-plugin/config', formData, options).pipe(
        map((response: any) => response.data.integration)
    );
  }
}
